import { render, staticRenderFns } from "./ActivityLayout.vue?vue&type=template&id=514a2ca1&scoped=true"
import script from "./ActivityLayout.vue?vue&type=script&lang=js"
export * from "./ActivityLayout.vue?vue&type=script&lang=js"
import style0 from "./ActivityLayout.vue?vue&type=style&index=0&id=514a2ca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a2ca1",
  null
  
)

export default component.exports